import { ROLE_PERMISSIONS, type Permission, type Role } from "@cliently/types";
import { useAuthStore } from "../stores/auth.store";



export const usePermissions = () => {
  const user = useAuthStore((s) => s.user);
  const role = ((user?.role as Role | undefined) ?? "AGENT") as Role;
  const permissions = ROLE_PERMISSIONS[role] ?? [];

  return {
    role,
    permissions,
    can: (permission: Permission) => permissions.includes(permission),
    canAny: (...perms: Permission[]) =>
      perms.some((p) => permissions.includes(p)),
    canAll: (...perms: Permission[]) =>
      perms.every((p) => permissions.includes(p)),
    isAdmin: role === "ADMIN",
  };
}
